<template>
  <div id="bottomLeft">
    <div class="bg-color-black ">
      <div class="u-f u-ac u-jsb">
        <div class="d-flex pt-2 pl-2">
          <span>
            <icon name="chart-bar" class="text-icon"></icon>
          </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">用户AU</span>
          </div>
        </div>
        <div class="rzy_qh u-f u-ac">
          <div class="qh_btn" @click="ridata(1)">日</div>
          <div class="qh_btn" @click="ridata(3)">周</div>
          <div class="qh_btn" @click="ridata(2)">月</div>
        </div>
      </div>

      <div>
        <BottomLeftChart />
      </div>
    </div>
  </div>
</template>

<script>
  import BottomLeftChart from '@/components/echart/bottom/bottomLeftChart'
  export default {
    components: {
      BottomLeftChart
    },
    methods:{
      ridata(t){
        this.$nextTick(()=>{
          this.$parent.$parent.getdau(t)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  $box-height: 520px;
  // $box-height: 400px;
  $box-width: 100%;

  #bottomLeft {
    padding: 20px 16px;
    height: $box-height;
    width: $box-width;
    border-radius: 5px;

    .bg-color-black {
      height: $box-height - 35px;
      border-radius: 10px;
      .rzy_qh{
        margin-right: 10px;
        .qh_btn{
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    .text {
      color: #c3cbde;
    }

    .chart-box {
      margin-top: 16px;
      width: 170px;
      height: 170px;

      .active-ring-name {
        padding-top: 10px;
      }
    }
  }
</style>